import { inject, Injectable, signal } from '@angular/core';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { _HttpClient } from '@delon/theme';

@Injectable({
  providedIn: 'root'
})
export class CopyTransactionService {
  #http = inject(_HttpClient);
  #copyUrl = `/api/copy?sourceType={st}&id={id}&destType={dt}`;
  copyIsActivated = signal(false);

  getCopyData(routeParams: any) {
    return this.#http.get(
      this.#copyUrl
        .replace('{st}', routeParams['source'])
        .replace('{dt}', routeParams['destination'])
        .replace('{id}', routeParams['id'])
    );
  }

  searchTransactions(data: any) {
    return this.#http.post('/api/copy/search?_silent=true', data);
  }
}
